import React from 'react';
import TextField from '@mui/material/TextField';

export default function Text({ label, value, disabled, onChange, autoFocus }) {
  return <TextField
    multiline
    minRows={3}
    fullWidth={true}
    disabled={disabled}
    value={value}
    helperText={label}
    onChange={onChange}
    autoFocus={autoFocus}
  />;
}
